import { useState } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import { useSelector } from "react-redux";
import { selectSubjectList } from "../../../../redux/curriculum/subjectListSlice";
import { scheduleDelete } from "../../../../redux/curriculum/scheduleInsUpdSlice";
import { scheduleListSlice } from "../../../../redux/curriculum/scheduleListSlice";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { ScheduleInfo } from "../../../../redux/curriculum/model";

export interface ScheduleDeleteModalProps {
    schedule: ScheduleInfo | undefined;
    onClose: () => void;
}

export function ScheduleDeleteModal({ schedule, onClose }: ScheduleDeleteModalProps) {
    const dispatch = useAppDispatch();
    const subjects = useSelector(selectSubjectList);
    const [deleting, setDeleting] = useState(false);

    const subjectName = schedule
        ? (subjects.list?.find((s) => s.id == schedule.subjectId)?.name
            || `Disciplina ${schedule.subjectId}`)
        : "";

    return (
        <Dialog
            open={schedule !== undefined}
            onClose={() => {
                if (!deleting) {
                    onClose();
                }
            }}>
            <DialogTitle>Remover Horário</DialogTitle>
            <DialogContent>
                <Typography>
                    Tem certeza que deseja remover o horário
                    {schedule && (
                        <>
                            {" "}<b>
                                {subjectName}
                                {` (${schedule.startTime} - ${schedule.endTime})`}
                            </b>
                        </>
                    )}
                    ?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={deleting}>
                    Cancelar
                </Button>
                <Button
                    color="error"
                    variant="contained"
                    disabled={deleting}
                    onClick={async () => {
                        if (!schedule) {
                            return;
                        }
                        try {
                            setDeleting(true);
                            await dispatch(scheduleDelete({ scheduleId: `${schedule.id}` })).unwrap();
                            dispatch(scheduleListSlice.actions.clean());
                            onClose();
                        } finally {
                            setDeleting(false);
                        }
                    }}>
                    Remover
                </Button>
            </DialogActions>
        </Dialog>
    );
}
